import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import React from 'react';

interface BuildingCartSummaryProps {
  cartTotal: number;
  buildingTotal?: number;
  gableTotal?: number;
  headerTotal?: number;
  leanToTotal?: number;
  onReturnToCheckout: () => void;
  onUpdateCart?: () => void;
  onRemoveFromCart?: () => void;
  showBuildingDetails?: boolean;
  isSubmitting?: boolean;
  hasTrussChanges?: boolean;
}

export const BuildingCartSummary: React.FC<BuildingCartSummaryProps> = ({
  cartTotal,
  buildingTotal,
  gableTotal,
  headerTotal,
  leanToTotal,
  onReturnToCheckout,
  onUpdateCart,
  onRemoveFromCart,
  showBuildingDetails = false,
  isSubmitting = false,
  hasTrussChanges = true,
}) => {
  if (showBuildingDetails) {
    return (
      <Paper
        elevation={2}
        sx={{
          p: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Typography variant="body2" sx={{ mb: 0.5, color: 'text.secondary', fontWeight: 500 }}>
            Building Total
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary' }}>
            ${(buildingTotal || 0).toFixed(2)}
          </Typography>
        </Box>
        <Divider sx={{ mb: 3 }} />
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
            Totals by Truss Type:
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            Gable: ${(gableTotal || 0).toFixed(2)}
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            Header: ${(headerTotal || 0).toFixed(2)}
          </Typography>
          <Typography variant="body2">Lean-to: ${(leanToTotal || 0).toFixed(2)}</Typography>
        </Box>
        <Divider sx={{ mb: 3 }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {onUpdateCart && (
            <Button
              variant="contained"
              fullWidth
              onClick={onUpdateCart}
              disabled={isSubmitting || !hasTrussChanges}
              sx={{ py: 1.5 }}
            >
              {isSubmitting ? 'Updating...' : 'Update Cart'}
            </Button>
          )}
          {onRemoveFromCart && (
            <Button
              variant="outlined"
              color="error"
              fullWidth
              onClick={onRemoveFromCart}
              sx={{ py: 1.5 }}
            >
              Remove from Cart
            </Button>
          )}
        </Box>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ mb: 3 }}>
        <Typography variant="body2" sx={{ mb: 0.5, color: 'text.secondary', fontWeight: 500 }}>
          Your Cart Total
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary' }}>
          ${cartTotal.toFixed(2)}
        </Typography>
      </Box>
      <Divider sx={{ mb: 3 }} />
      <Button variant="contained" fullWidth onClick={onReturnToCheckout} sx={{ py: 1.5 }}>
        Return to Checkout
      </Button>
    </Paper>
  );
};
